const config = {
  apiBaseUrl: 'http://localhost:8085',
};

export default config;
